import { data } from "./planner.data";

var start = (function () { 
    const welcomeContainer = document.getElementById('welcome');
    const plannerContainer = document.getElementById('planner');
    const btnFindTeam = document.getElementById('btn-find-team');
    const inputFPLTeamId = document.getElementById('fplteamid');
    const teamFoundContainer = document.getElementById('team-found-container');
    const teamName = document.getElementById('team-name');
    const findTeamContainer = document.getElementById('find-team-container');
    const alertTeamNotFound = document.getElementById('alert-team-not-found');
    const btnConfirmTeam = document.getElementById('btn-confirm-team');
    const btnRetryTeam = document.getElementById('btn-retry-team');
    const loadingTeam = document.getElementById("loading-team");

    const newData = new CustomEvent("newData", {});

    var fplTeamName = "";

    function retryFindTeam()
    {
        inputFPLTeamId.value = "";
        
        teamFoundContainer.classList.add("hide");
        findTeamContainer.classList.remove("hide");

        inputFPLTeamId.focus();
    }

    function getFPLTeam()
    {
        alertTeamNotFound.classList.add("hide");

        const teamId = inputFPLTeamId.value;

        if (teamId !== "")
        {
            (async () => {
                var fplTeam = await data.getFPLTeam(teamId);

                if (fplTeam === undefined || fplTeam === null) {
                    alertTeamNotFound.classList.remove("hide");
                    inputFPLTeamId.focus();
                }
                else {
                    findTeamContainer.classList.add("hide");
                    teamFoundContainer.classList.remove("hide");
                    teamName.innerHTML = fplTeam.name;
                    fplTeamName = fplTeam.name;
                }            
            })()
        }
    }

    function loadTeam()
    {
        teamFoundContainer.classList.add("hide");
        loadingTeam.classList.remove("hide");

        const teamId = inputFPLTeamId.value;

        if (teamId !== "")
        {
            (async () => {
                await data.setup(teamId, fplTeamName);
            })().then(() => {
                showPlanner();
            });
        }
    }

    function showPlanner()
    {
        welcomeContainer.classList.add("hide");
        plannerContainer.classList.remove("hide");

        document.dispatchEvent(newData);
    }

    function bindEvents()
    {
        btnFindTeam.addEventListener('click', function () {
            getFPLTeam();
        });

        btnRetryTeam.addEventListener('click', function () {
            retryFindTeam();
        });

        btnConfirmTeam.addEventListener("click", function () {
            loadTeam();
        });

        inputFPLTeamId.addEventListener("input", function (e) {
            inputFPLTeamId.value = e.target.value.replace(/[^0-9.]/g,'').replace(/(\..*)\./g, '$1');
        })
    }
    
    async function init() {    
        bindEvents();

        await data.loadData().then(() => {
            console.log(data.getValues().fplTeam && parseInt(data.getValues().fplTeam.fplTeamId) > 0);
            if (data.getValues().fplTeam && parseInt(data.getValues().fplTeam.fplTeamId) > 0) {
                showPlanner();
                console.log("Data loaded from local storage");
            }
        });        
    }

    return {
        init: init
    };
})();

export { start }